import React from 'react';
import styled from 'styled-components'
import theme from '../Theme'

const shrunkenButton = "83%";
const linkActivateTime = "0.1s";
const linkDeactivateTime = "0.7s";
const buttonSelectedColor = theme.highlight;
const buttonDeselectedColor = theme.dark;
const labelFontFamily = theme.titleFont.fontFamily;

const ContactButtonContainer = styled.a`
    margin-bottom: 32px;
    cursor: pointer;
    width: 190px;
    text-decoration: none;

    &:hover {
        text-decoration: none;
    }

    .image-button {
        height: 100px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        svg {
            width: ${shrunkenButton};
            height: ${shrunkenButton};
            transition: ${linkDeactivateTime};

            .icon-path {
                fill: ${buttonDeselectedColor};
                transition: ${linkDeactivateTime};
            }
        }

    }

    .label-container {
        padding-top: 4px;
        text-align: center;
        text-transform: uppercase;
        transition: ${linkDeactivateTime};
        color: ${buttonDeselectedColor};
        font-family: ${labelFontFamily};
        font-weight: 100;
    }

    .sublabel-container {
        text-align: center;
        transition: ${linkDeactivateTime};
        color: ${buttonDeselectedColor};
        text-transform: none;
        font-family: ${labelFontFamily};
        font-weight: 100;
        font-size: 14px;
    }

    /* Hover */

    &:hover {
        .image-button {
            svg {
                width: 100%;
                height: 100%;
                transition: ${linkActivateTime};

                .icon-path {
                    fill: ${buttonSelectedColor};
                    transition: ${linkActivateTime};
                }
            }
        }
        
        .label-container {
            transition: ${linkActivateTime};
            color: ${buttonSelectedColor};
        }

        
        .sublabel-container {
            transition: ${linkActivateTime};
            color: ${buttonSelectedColor};
        }
    }
`

export const ContactButton = (props) => (
    <ContactButtonContainer href={props.href} target="_blank">
        <div className="image-button">
            {props.children}
        </div>
        <div className="labels-container">
            <div className="label-container">{props.caption}</div>
            <div className="sublabel-container">{props.subcaption}</div>
        </div>
    </ContactButtonContainer>
)
        
